import { styled as StyledMui } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as NavigationHomeIcon } from "../../assests/icons/navigation_home.svg";
import { ReactComponent as NavigationArrow } from "../../assests/icons/navigation_arrow.svg";

export const HeaderNavigationBox = StyledMui(Box)(({isHeaderShrink}) => ({
  marginTop: "0.5rem",
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "baseline",
  columnGap: "1rem",
  "*":{fontSize: String(isHeaderShrink) === "true" && "12px" },
  
  "@media only screen and (max-width: 1180px)":{
    "*":{fontSize: "1.2rem",
  }
  },
  "@media only screen and (max-width: 850px)":{
    display:"none"
  }
}));

export const HeaderNavigationText = StyledMui(Typography)((props) => ({
  fontWeight: props.isbold==="true" ? 700 : "normal",
  userSelect: "none",
}));

export const StyledNavigationArrow = StyledMui(NavigationArrow)(({isHeaderShrink}) => ({
  height:String(isHeaderShrink) === "true" && "1.1rem",
  "@media only screen and (max-width: 1180px)":{
    width:"0.68rem"
 }
}));

export const HeaderNavigationLink = StyledMui(Link)((props) => ({
  color: "#ffffff",
  fontSize: "1.6rem",
  textDecoration: "none",
  fontWeight: props.isbold==="true" ? 700 : "normal",
  "&:hover":{
    boxShadow: props.isbold==="false"&& "0px 3px 0px -1px #ffffff"
  }
}));

export const HeaderNavigationHomeIcon = StyledMui(NavigationHomeIcon)(({isHeaderShrink}) => ({
  cursor:"pointer",
  width:String(isHeaderShrink) === "true" && "1.8rem",
  height:String(isHeaderShrink) === "true" && "15px",
  "@media only screen and (max-width: 1180px)":{
    width:"2rem"
    },
}));
